import { 
  faCircle
} from '@fortawesome/free-regular-svg-icons'
import { 
  faCheckCircle, 
  faPlus, 
  faTimes, 
  faExpandAlt, 
  faCompressAlt, 
  faCaretDown,
  faSignOutAlt
} from '@fortawesome/free-solid-svg-icons'

export const farIcons = [
  faCircle,
]

export const fasIcons = [
  faCheckCircle,
  faPlus,
  faTimes,
  faExpandAlt, 
  faCompressAlt,
  faCaretDown,
  faSignOutAlt,
]